import React from 'react';

type UseDialogResult = {
  ref: React.RefObject<HTMLDivElement>;
  show: boolean;
  handleShow: () => void;
  handleHide: () => void;
  handleToggleVisibility: () => void;
};

export const useDialog = (): UseDialogResult => {
  const ref = React.useRef<HTMLDivElement>(null);
  const [show, setShow] = React.useState(false);
  const handleShow = () => setShow(true);
  const handleHide = () => setShow(false);
  const handleToggleVisibility = () => setShow(!show);

  React.useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!ref?.current?.contains(e.target)) handleHide();
    };
    const handleEsc = (e: KeyboardEvent) => {
      if (e.keyCode === 27) handleHide();
    };

    if (show) {
      document.addEventListener('keydown', handleEsc);
      document.addEventListener('click', handleClick);
    }

    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.removeEventListener('click', handleClick);
    };
  }, [show]);

  return {
    ref,
    show,
    handleShow,
    handleHide,
    handleToggleVisibility,
  };
};
